import { render } from "./Ad.vue?vue&type=template&id=cc0688fa&scoped=true"
import script from "./Ad.vue?vue&type=script&lang=js"
export * from "./Ad.vue?vue&type=script&lang=js"

import "./Ad.vue?vue&type=style&index=0&id=cc0688fa&scoped=true&lang=css"
import "./Ad.vue?vue&type=style&index=1&id=cc0688fa&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/海/vue-antd-tool-web 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0688fa"]])

export default __exports__